<template>
  <div class="w-100">
    <!-- STEP choose_template -->
    <div v-if="currentStep == 'choose_template'" class="">
      <h5 class="font-weight-bolder">
        <b>
          <!-- Choose a template -->
          Choose an existing resume
        </b>
      </h5>

      <b-overlay :show="isLoading" rounded="sm" style="height:45vh;">
        <div class="mx-md-1 template-export-container">
          <div v-for="template in resumeTemplates" :key="template.id" class="template-export-img-container">
            <div>
              <img 
                class="resume-border cursor-pointer" alt="Resume Template" :src="template.image_file_link"
                style="max-height:45vh;" @click="chooseTemplate(template)">
            </div>
            <!-- <img
                          class="resume-border cursor-pointer"
                          alt="Resume Template"
                          :src="template"
                          style="max-height: 45vh;"
                          @click="nextStep"
                      /> -->
            <!-- @click="selectTemplate(template)" -->
          </div>
        </div>
      </b-overlay>
      <div class="d-flex justify-content-center gap-2">
        <router-link :to="{name: 'dashboard'}">
          <b-button class="mt-4 default-button-style">
            Back
          </b-button>
        </router-link>
      </div>
    </div>

    <!-- STEP introduction -->
    <div v-if="currentStep == 'introduction'" class="text-start">
      <b-row class="justify-content-md-center">
        <b-col cols="12" md="6">
          <h5 class="m-0 p-0 font-weight-bolder">
            <b>
              <!-- It will take roughly about 20 minutes to complete building this new resume. Please prepare the following information: -->
              Please select the section you want to edit
            </b>
          </h5>

          <div>
            <small> Items marked with (
              <input-required-marker /> ) are required </small>
          </div>

          <ol class="m-0 mt-2">
            <li class="font-weight-bold">
              Personal Information
              <input-required-marker />

              <div class="d-flex flex-row flex-gap-md font-weight-normal">
                <b-form-checkbox :checked="true" />
                Position you are looking for
                <input-required-marker />
              </div>
              <div class="d-flex flex-row flex-gap-md font-weight-normal">
                <b-form-checkbox :checked="true" />
                Name
                <input-required-marker />
              </div>
              <div class="d-flex flex-row flex-gap-md font-weight-normal">
                <b-form-checkbox :checked="true" />
                About Me
                <input-required-marker />
              </div>
            </li>
            <li>
              Contact Information

              <div class="d-flex flex-row flex-wrap flex-gap-md font-weight-normal">
                <div class="d-flex flex-row flex-gap-md">
                  <b-form-checkbox :checked="true" />
                  Email
                  <input-required-marker />
                </div>
                <div class="ps-4 ps-md-0">
                  (Proxy Email available in both Digital & Downloaded resume version)
                </div>
              </div>
              <div class="d-flex flex-row flex-wrap flex-gap-md font-weight-normal">
                <div class="d-flex flex-row flex-gap-md">
                  <b-form-checkbox :checked="true" />
                  Phone Number
                  <input-required-marker />
                </div>
                <div class="ps-4 ps-md-0">
                  (Proxy Number available in Digital resume version only)
                </div>
              </div>
              <div class="d-flex flex-row flex-gap-md font-weight-normal">
                <b-form-checkbox :checked="true" />
                Residential Address
              </div>
              <div class="d-flex flex-row flex-gap-md font-weight-normal">
                <b-form-checkbox :checked="true" />
                Website
              </div>
            </li>
            <li>
              Employment Information
              <input-required-marker />
            </li>
            <li>
              Education Information
              <input-required-marker />
            </li>
            <li>
              Skills
              <input-required-marker />

              <div class="d-flex flex-row flex-gap-md font-weight-normal">
                <b-form-checkbox :checked="true" />
                Hard Skills
                <input-required-marker />
              </div>
              <div class="d-flex flex-row flex-gap-md font-weight-normal">
                <b-form-checkbox :checked="true" />
                Soft Skills
                <input-required-marker />
              </div>
            </li>
          </ol>

          <div class="mt-1 d-flex justify-content-center">
            <b-button class="default-button-style" @click="backStep">
              Back
            </b-button>

            <b-button class="default-button-style" @click="createNewResume">
              Create Resume
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>

    <!-- STEP personal_informations -->
    <div v-if="currentStep == 'personal_informations'">
      <StepTitle>
        <template v-if="actionType == 'create'">
          We will first populate your Personal Information fields. Please refer to the following example image for
          reference on which section you will be populating
        </template>
        <template v-else>
          We will first edit your Personal Information fields.
        </template>
      </StepTitle>

      <div class="mt-2 d-flex flex-row d-md-none w-100 flex-gap-sm">
        <b-button size="sm" :class="`flex-fill default-button${show.preview == true? '-outline' : ''}-color`"
          @click="() => {show.preview = false; show.form = true}"> Form </b-button>
        <b-button size="sm" :class="`flex-fill default-button${show.preview == false? '-outline' : ''}-color`"
          @click="() => {show.preview = true; show.form = false}"> Preview </b-button>
      </div>

      <div :class="customClasses.formContainer">
        <div v-if="show.form" :class="`mt-2 ${customClasses.inputContainer}`">
          <div>
            <form-question>
              What position are you looking for?
            </form-question>
            <b-input v-model="resumeData.personal_informations.looking_for_position" class="border border-dark"
              @input="checkNextButtonDisabled" autofocus />
          </div>

          <div>
            <form-question>
              What is your Name?
              <input-required-marker />
            </form-question>
            <b-input v-model="resumeData.personal_informations.name" class="border border-dark"
              @input="checkNextButtonDisabled" />
          </div>
        </div>

        <div v-if="show.preview" :class="`d-flex justify-content-center ${customClasses.previewContainer}`" class="">
          <div class="preview-container">
            <img alt="Profile Information Preview"
              :src="`${selectedTemplate.image_file_link}?${(Math.random() + 1).toString(36).substring(7)}`"
              :style="`height: ${previewHeight}vh;`">
            <div class="opacity-color" />
            <img alt="Profile Information Preview"
              :src="`${selectedTemplate.image_file_link}?${(Math.random() + 1).toString(36).substring(7)}`" :style="`
                    height: ${previewHeight}vh; 
                    clip-path: polygon(${maskOptions.personal_informations});
                  `">
          </div>
          <!-- style="
                  height: 60vh; clip-path: polygon(50% 30%, 100% 30%, 100% 70%, 50% 100%);
                " -->
        </div>
      </div>

      <div class="d-flex justify-content-center gap-2">
        <b-button class="mt-4 default-button-style" @click="backStep">
          Back
        </b-button>

        <b-button class="mt-4 default-button-style" @click="nextStep" :disabled="nextButtonDisabled">
          Continue
        </b-button>
      </div>
    </div>

    <!-- STEP personal_information_field_about_me -->
    <div v-if="currentStep == 'personal_information_field_about_me'" class="w-100">
      <StepTitle>
        <template v-if="actionType == 'create'">
          Tell us about yourself.
        </template>
        <template v-else>
          Tell us more about yourself.
        </template>
      </StepTitle>

      <div class="mt-2 d-flex flex-row d-md-none w-100 flex-gap-sm">
        <b-button size="sm" :class="`flex-fill default-button${show.preview == true? '-outline' : ''}-color`"
          @click="() => {show.preview = false; show.form = true}"> Form </b-button>
        <b-button size="sm" :class="`flex-fill default-button${show.preview == false? '-outline' : ''}-color`"
          @click="() => {show.preview = true; show.form = false}"> Preview </b-button>
      </div>

      <div :class="customClasses.formContainer">
        <div v-if="show.form" :class="`mt-2 ${customClasses.inputContainer}`">
          <b-row class="justify-content-md-center">
            <b-col cols="12">

              <div class="d-flex flex-row flex-gap-sm justify-content-between align-items-center">
                <form-question class="flex-fill">
                  Tell us about yourself
                  <input-required-marker />
                </form-question>

                <div class="flex-fill d-flex flex-row justify-content-end flex-gap-sm">
                  <b-button class="default-button-color" @click="resumeData.personal_informations.about_me = null">
                    <font-awesome-icon size="sm" icon="fa-solid fa-trash" />
                  </b-button>

                  <b-button v-if="false" class="default-button-color">
                    <font-awesome-icon class="d-block d-md-none" size="sm" icon="fa-solid fa-brain" />
                    <div class="d-none d-md-block">
                      Generate with AI
                    </div>
                  </b-button>
                </div>

              </div>

              <b-form-textarea v-model="resumeData.personal_informations.about_me" class="mt-2 input-border" rows="5"
                @input="checkNextButtonDisabled" autofocus />
              <template v-if="false">
                <h6 class="mt-2 text-start">Suggested Changes: </h6>
                <div class="suggested-badge">
                  {{resumeData.personal_informations.about_me_generated[0]}}
                </div>
              </template>
            </b-col>
          </b-row>
        </div>

        <div v-if="show.preview" :class="`d-flex justify-content-center ${customClasses.previewContainer}`" class="">
          <div class="preview-container">
            <img alt="Profile Information Preview"
              :src="`${selectedTemplate.image_file_link}?${(Math.random() + 1).toString(36).substring(7)}`"
              :style="`height: ${previewHeight}vh;`">
            <div class="opacity-color" />
            <img alt="Profile Information Preview"
              :src="`${selectedTemplate.image_file_link}?${(Math.random() + 1).toString(36).substring(7)}`" :style="`
                    height: ${previewHeight}vh; 
                    clip-path: polygon(${maskOptions.about_me});
                  `">
          </div>
          <!-- style="
                  height: 60vh; clip-path: polygon(50% 30%, 100% 30%, 100% 70%, 50% 100%);
                " -->
        </div>
      </div>

      <div class="d-flex justify-content-center gap-2">
        <b-button class="mt-4 default-button-style" @click="backStep">
          Back
        </b-button>

        <b-button class="mt-4 default-button-style" @click="updateResumeData" :disabled="nextButtonDisabled">
          Continue
        </b-button>
      </div>
    </div>

    <!-- STEP contect_informations -->
    <div v-if="currentStep == 'contact_informations'">
      <StepTitle>
        <template v-if="actionType == 'create'">
          Contact informations are important as it helps recruiters to get in touch with you, make sure to fill in
          valid infomations.
        </template>
        <template v-else>
          Remember to keep your contact information up-to-date. It helps recruiters connect with you for potential
          opportunities.
        </template>
      </StepTitle>

      <div class="mt-1 d-flex flex-row d-md-none w-100 flex-gap-sm">
        <b-button size="sm" :class="`flex-fill default-button${show.preview == true? '-outline' : ''}-color`"
          @click="() => {show.preview = false; show.form = true}"> Form </b-button>
        <b-button size="sm" :class="`flex-fill default-button${show.preview == false? '-outline' : ''}-color`"
          @click="() => {show.preview = true; show.form = false}"> Preview </b-button>
      </div>

      <div :class="customClasses.formContainer">
        <div v-if="show.form" :class="`mt-2 ${customClasses.inputContainer}`">
          <div>
            <form-question>
              What is your Email Address?
              <input-required-marker />
            </form-question>

            <!-- <form-question-input /> -->
            <b-input v-model="resumeData.contact_informations.email_address" class="border border-dark"
              @input="checkNextButtonDisabled" autofocus />

            <div v-if="false" class="mt-1 d-flex flex-row gap-1">
              <b-form-checkbox v-model="resumeData.contact_informations.email_mask" @change="changedEmailMask" />
              <div class="ml-1 text-start">
                Mask my email address
              </div>
            </div>

            <div v-if="resumeData.contact_informations.email_mask" class="mt-2 text-center">
              <!-- <b>Your email will be masked in both the digital and downloaded resume</b> -->
              <b-alert :show="resumeData.contact_informations.email_mask">Your email will be masked in both the
                digital and downloaded resume
              </b-alert>
            </div>
          </div>

          <div>
            <form-question>
              What is your Phone Number?
              <input-required-marker />
            </form-question>

            <!-- <form-question-input /> -->
            <b-input v-model="resumeData.contact_informations.phone_number" class="border border-dark"
              @input="checkNextButtonDisabled" autofocus />

            <div v-if="false" class="mt-1 d-flex flex-row gap-1">
              <b-form-checkbox v-model="resumeData.contact_informations.phone_number_mask" />
              <div class="ml-1 text-start">
                Mask my phone number
              </div>
            </div>

            <div v-if="resumeData.contact_informations.phone_number_mask" class="mt-4 text-center">
              <!-- <b> A masked phone number will be generated in the generated resume </b> -->
              <b-alert :show="resumeData.contact_informations.phone_number_mask"> A masked phone number will be
                generated in the generated resume </b-alert>
            </div>

          </div>

          <div>
            <form-question>
              Where do you live?
            </form-question>

            <b-form-textarea v-model="resumeData.contact_informations.residential_address" class="border border-dark"
              rows="1" @input="checkNextButtonDisabled" />
          </div>

          <div>
            <form-question>
              Do you have a Website? Let us know if you have one
            </form-question>

            <!-- <form-question-input /> -->
            <b-input v-model="resumeData.contact_informations.website" class="border border-dark" autofocus
              @input="checkNextButtonDisabled" />
          </div>

        </div>

        <div v-if="show.preview" :class="`d-flex justify-content-center ${customClasses.previewContainer}`" class="">
          <div class="preview-container">
            <img alt="Profile Information Preview"
              :src="`${selectedTemplate.image_file_link}?${(Math.random() + 1).toString(36).substring(7)}`"
              :style="`height: ${previewHeight}vh;`">
            <div class="opacity-color" />
            <img alt="Profile Information Preview"
              :src="`${selectedTemplate.image_file_link}?${(Math.random() + 1).toString(36).substring(7)}`" :style="`
                    height: ${previewHeight}vh; 
                    clip-path: polygon(${maskOptions.contact_informations});
                  `">
          </div>
          <!-- style="
                  height: 60vh; clip-path: polygon(50% 30%, 100% 30%, 100% 70%, 50% 100%);
                " -->
        </div>
      </div>

      <div class="d-flex justify-content-center gap-2">
        <b-button class="mt-4 default-button-style" @click="backStep">
          Back
        </b-button>

        <b-button class="mt-4 default-button-style" @click="nextStep">
          Continue
        </b-button>
      </div>
    </div>

    <!-- STEP employment_information_fofm -->
    <div v-if="currentStep == 'employment_information_form'" class="w-100">
      <StepTitle>
        <template v-if="actionType == 'create'">
          Okay, please tell us where you have worked previously
        </template>
        <template v-else>
          Any changes to your Employment Information?
        </template>
      </StepTitle>

      <div class="mt-2 d-flex flex-row d-md-none w-100 flex-gap-sm">
        <b-button size="sm" :class="`flex-fill default-button${show.preview == true? '-outline' : ''}-color`"
          @click="() => {show.preview = false; show.form = true}"> Form </b-button>
        <b-button size="sm" :class="`flex-fill default-button${show.preview == false? '-outline' : ''}-color`"
          @click="() => {show.preview = true; show.form = false}"> Preview </b-button>
      </div>

      <div :class="customClasses.formContainer">
        <div v-if="show.form" :class="`mt-2 ${customClasses.inputContainer}`">
          <b-row class="m-0 p-0 justify-content-md-center">
            <b-col class="m-0 p-0" cols="12">
              <div class="employment-field-container">
                <form-question>
                  What did you work as previously? (E.g. : Accountant)
                  <input-required-marker />
                </form-question>

                <!-- <form-question-input v-model="resumeData.employment[0].position_title" @input="populateJobDescription" /> -->
                <b-input v-model="resumeData.employments[employmentStep].position_title" class="border border-dark"
                  autofocus @input="checkNextButtonDisabled"></b-input>
              </div>

              <div class="employment-field-container">
                <form-question>
                  Which company did you worked for?
                  <input-required-marker />
                </form-question>

                <!-- <form-question-input /> -->
                <b-input v-model="resumeData.employments[employmentStep].company" class="border border-dark"
                  @input="checkNextButtonDisabled" />
              </div>

              <b-row>
                <b-col>
                  <div class="employment-field-container">
                    <form-question>
                      Start Date
                      <input-required-marker />
                    </form-question>

                    <b-form-datepicker v-model="resumeData.employments[employmentStep].start_date"
                      class="border border-dark"
                      :date-format-options="{ year: 'numeric', month: 'short', day: 'numeric' }" :max="max_date_today"
                      dropleft size="md" locale="en" @input="checkNextButtonDisabled"></b-form-datepicker>
                  </div>
                </b-col>

                <b-col>
                  <div class="employment-field-container">
                    <form-question>
                      End Date
                      <input-required-marker />
                    </form-question>

                    <!-- <form-question-input /> -->
                    <b-form-datepicker v-model="resumeData.employments[employmentStep].end_date"
                      class="border border-dark"
                      :date-format-options="{ year: 'numeric', month: 'short', day: 'numeric' }" :max="max_date_today"
                      dropright size="md" locale="en" @input="checkNextButtonDisabled"></b-form-datepicker>

                    <div class="mt-1 d-flex flex-row gap-1">
                      <b-form-checkbox v-model="resumeData.employments[employmentStep].still_work_here" class=""
                        @change="changeEmploymentEndDate" />
                      <div class="ml-1 text-start">
                        I am working with the company
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>

              <div class="employment-field-container">
                <div class="d-flex flex-row flex-gap-md flex-wrap justify-content-between align-items-center">
                  <form-question class="flex-fill">
                    Please tell us about the job
                    <input-required-marker />
                  </form-question>

                  <div class="flex-fill d-flex flex-row justify-content-end flex-gap-sm">
                    <b-button class="default-button-color"
                      @click="resumeData.employments[employmentStep].job_description = null">
                      <
                    </b-button>

                    <b-button v-if="false" class="default-button-color">
                      <font-awesome-icon class="d-block d-md-none" size="sm" icon="fa-solid fa-brain" />
                      <div class="d-none d-md-block">
                        Generate with AI
                      </div>
                    </b-button>
                  </div>
                </div>

                <div v-if="false" class="mt-1 d-flex flex-row gap-1">
                  <b-form-checkbox class="" />
                  <div class="ml-1 text-start">
                    Auto populate job description field
                  </div>
                </div>

                <!-- <form-question-input v-model="resumeData.employment[0].job_description" /> -->
                <b-form-textarea v-model="resumeData.employments[employmentStep].job_description"
                  class="mt-1 border border-dark" rows="3" @input="checkNextButtonDisabled"></b-form-textarea>

                <template v-if="false">
                  <h6 class="mt-2 text-start">Suggested Changes: </h6>
                  <div class="suggested-badge">
                    {{resumeData.employments[employmentStep].job_description_generated[0]}}
                  </div>
                </template>

              </div>
            </b-col>
          </b-row>
        </div>

        <div v-if="show.preview" :class="`d-flex justify-content-center ${customClasses.previewContainer}`" class="">
          <div class="preview-container">
            <img alt="Profile Information Preview"
              :src="`${selectedTemplate.image_file_link}?${(Math.random() + 1).toString(36).substring(7)}`"
              :style="`height: ${previewHeight}vh;`">
            <div class="opacity-color" />
            <img alt="Profile Information Preview"
              :src="`${selectedTemplate.image_file_link}?${(Math.random() + 1).toString(36).substring(7)}`" :style="`
                    height: ${previewHeight}vh; 
                    clip-path: polygon(${maskOptions.employment_informations});
                  `">
          </div>
          <!-- style="
                  height: 60vh; clip-path: polygon(50% 30%, 100% 30%, 100% 70%, 50% 100%);
                " -->
        </div>
      </div>

      <div class="d-flex justify-content-center gap-2">
        <b-button class="mt-4 default-button-style" @click="backStep">
          Back
        </b-button>

        <b-button class="mt-4 default-button-style" @click="updateResumeData" :disabled="nextButtonDisabled">
          Continue
        </b-button>
      </div>
    </div>

    <!-- STEP employment_information_ask_add_more -->
    <div v-if="currentStep == 'employment_information_ask_add_more'" class="w-100">
      <b-row class="justify-content-md-center">
        <b-col cols="12" md="5">
          <h5 class="font-weight-bolder text-center text-md-center">
            <b class="text-center">
              Do you want to add another Employment Information?
            </b>
          </h5>

          <div class="mt-2 d-flex flex-row justify-content-center">
            <b-button class="default-button-style" @click="jumpToStep('education_information_form')">
              No
            </b-button>

            <b-button class="default-button-style" @click="addMoreEmployment">
              Yes
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>

    <!-- STEP education_information_form -->
    <div v-if="currentStep == 'education_information_form'" class="w-100">

      <StepTitle>
        <template v-if="actionType == 'create'">
          All right, we are almost there. Now lets add some Education Information
        </template>
        <template v-else>
          Any changes to your Education Information?
        </template>
      </StepTitle>

      <div class="mt-2 d-flex flex-row d-md-none w-100 flex-gap-sm">
        <b-button size="sm" :class="`flex-fill default-button${show.preview == true? '-outline' : ''}-color`"
          @click="() => {show.preview = false; show.form = true}"> Form </b-button>
        <b-button size="sm" :class="`flex-fill default-button${show.preview == false? '-outline' : ''}-color`"
          @click="() => {show.preview = true; show.form = false}"> Preview </b-button>
      </div>

      <div :class="customClasses.formContainer">
        <div v-if="show.form" :class="`mt-2 ${customClasses.inputContainer}`">
          <b-row class="justify-content-md-center">
            <b-col cols="12">
              <div class="education-field-container">
                <form-question>
                  What is your field of study?
                  <input-required-marker />
                </form-question>

                <!-- <form-question-input /> -->
                <b-input v-model="resumeData.educations[educationStep].field_of_study" class="border border-dark"
                  autofocus @input="checkNextButtonDisabled" />
              </div>

              <div class="education-field-container">
                <form-question>
                  Which institution issued the certificate?
                  <input-required-marker />
                </form-question>

                <!-- <form-question-input /> -->
                <b-input v-model="resumeData.educations[educationStep].institution" class="border border-dark"
                  @input="checkNextButtonDisabled" />
              </div>
              <b-row>
                <b-col>
                  <div class="education-field-container">
                    <form-question>
                      Start Date
                      <input-required-marker />
                    </form-question>

                    <b-form-datepicker 
                      v-model="resumeData.educations[educationStep].start_date"
                      class="border border-dark"
                      :date-format-options="{ year: 'numeric', month: 'short', day: 'numeric' }" 
                      :max="max_date_today"
                      dropleft size="md" locale="en" @input="checkNextButtonDisabled"></b-form-datepicker>
                  </div>
                </b-col>

                <b-col>
                  <div class="education-field-container">
                    <form-question>
                      End Date
                      <input-required-marker />
                    </form-question>

                    <b-form-datepicker v-model="resumeData.educations[educationStep].end_date"
                      class="border border-dark"
                      :date-format-options="{ year: 'numeric', month: 'short', day: 'numeric' }" :max="max_date_today"
                      dropright size="md" locale="en" @change="checkNextButtonDisabled"
                      @input="checkNextButtonDisabled"></b-form-datepicker>

                    <div class="mt-1 d-flex flex-row gap-1">
                      <b-form-checkbox v-model="resumeData.educations[educationStep].still_study_here" class=""
                        @change="changeEducationEndDate" />
                      <div class="ml-1 text-start">
                        Currently studying here
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>

              <div class="education-field-container">
                <div class="d-flex flex-row flex-gap-sm justify-content-between align-items-center">
                  <form-question class="flex-fill">
                    Please tell us more about this field of study
                  </form-question>

                  <div class="flex-fill d-flex flex-row justify-content-end flex-gap-sm">
                    <b-button
                      class="default-button-color"
                      variant="primary"
                      @click="resumeData.educations[educationStep].description = null"
                    >
                      <feather-icon
                        icon="TrashIcon"
                        size="16"
                      />
                    </b-button>

                    <b-button v-if="false" class="default-button-color">
                      <font-awesome-icon class="d-block d-md-none" size="sm" icon="fa-solid fa-brain" />
                      <div class="d-none d-md-block">
                        Generate with AI
                      </div>
                    </b-button>
                  </div>

                </div>

                <b-form-textarea v-model="resumeData.educations[educationStep].description" class="border border-dark"
                  rows="3" @input="checkNextButtonDisabled"> </b-form-textarea>

                <template v-if="false">
                  <h6 class="mt-2 text-start">Suggested Changes: </h6>
                  <div class="suggested-badge">
                    {{resumeData.educations[educationStep].description_generated[0]}}
                  </div>
                </template>
              </div>
            </b-col>
          </b-row>
        </div>

        <div v-if="show.preview" :class="`d-flex justify-content-center ${customClasses.previewContainer}`" class="">
          <div class="preview-container">
            <img alt="Profile Information Preview"
              :src="`${selectedTemplate.image_file_link}?${(Math.random() + 1).toString(36).substring(7)}`"
              :style="`height: ${previewHeight}vh;`">
            <div class="opacity-color" />
            <img alt="Profile Information Preview"
              :src="`${selectedTemplate.image_file_link}?${(Math.random() + 1).toString(36).substring(7)}`" :style="`
                    height: ${previewHeight}vh; 
                    clip-path: polygon(${maskOptions.education_informations});
                  `">
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-center gap-2">
        <b-button class="mt-4 default-button-style" @click="backStep">
          Back
        </b-button>

        <b-button class="mt-4 default-button-style" @click="updateResumeData" :disabled="nextButtonDisabled">
          Continue
        </b-button>
      </div>
    </div>

    <!-- STEP education_information_ask_add_more -->
    <div v-if="currentStep == 'education_information_ask_add_more'" class="w-100">
      <b-row class="justify-content-md-center">
        <b-col cols="12" md="5">
          <h5 class="font-weight-bolder text-center text-md-center">
            <b>
              Do you want to add another Education Information?
            </b>
          </h5>

          <div class="mt-2 d-flex flex-row justify-content-center">
            <b-button class="default-button-style" @click="nextStep">
              No
            </b-button>

            <b-button class="default-button-style" @click="addMoreEducation">
              Yes
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>

    <!-- STEP hard_skills -->
    <div v-if="currentStep == 'hard_skills'" class="w-100">
      <StepTitle>
        <template v-if="actionType == 'create'">
          Please tell us what hard skillsets you have
        </template>
        <template v-else>
          Any new hard skills to add?
        </template>
        <!-- We are almost done, let us know what hard skillsets you have -->
        <!-- Hard Skills -->
      </StepTitle>

      <div class="mt-2 d-flex flex-row d-md-none w-100 flex-gap-sm">
        <b-button size="sm" :class="`flex-fill default-button${show.preview == true? '-outline' : ''}-color`"
          @click="() => {show.preview = false; show.form = true}"> Form </b-button>
        <b-button size="sm" :class="`flex-fill default-button${show.preview == false? '-outline' : ''}-color`"
          @click="() => {show.preview = true; show.form = false}"> Preview </b-button>
      </div>

      <div :class="customClasses.formContainer">
        <div v-if="show.form" :class="`mt-2 ${customClasses.inputContainer}`">
          <b-row class="justify-content-md-center">
            <b-col cols="12">
              <!-- <h3 class="text-start">yyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyy</h3> -->

              <div class="mt-2">
                <form-question>
                  Hard skills
                  <input-required-marker />
                </form-question>

                <!-- <form-question-input v-model="skillInputValue" @on-enter="setSkill"/> -->
                <b-input v-model="hardSkillInputValue" v-on:keyup.enter="setHardSkill($event.target.value)"
                  class="border border-dark" />
                <div class="text-start">
                  <small>Press enter after typing a skill</small>
                </div>

                <div v-if="resumeData.hard_skills.length > 0" class="skills-container d-flex flex-wrap">
                  <div v-for="skill in resumeData.hard_skills" :key="skill.id" class="skill-badge">
                    {{ skill }}
                    <span class="cursor-pointer" aria-hidden="true"><b> &nbsp; &times; </b></span>
                  </div>
                </div>

                <template v-if="false">
                  <h5 class="mt-3 text-start">Suggested Skills</h5>
                  <div class="skills-container d-flex flex-wrap">
                    <div v-for="skill in hardSkillsSuggestion" :key="skill.id" class="suggested-skill-badge">
                      {{ skill }}
                      <span class="cursor-pointer" aria-hidden="true"><b> &nbsp; &plus; </b></span>
                    </div>
                  </div>
                </template>
              </div>
            </b-col>
          </b-row>
        </div>

        <div v-if="show.preview" :class="`d-flex justify-content-center ${customClasses.previewContainer}`" class="">
          <div class="preview-container">
            <img alt="Profile Information Preview"
              :src="`${selectedTemplate.image_file_link}?${(Math.random() + 1).toString(36).substring(7)}`"
              :style="`height: ${previewHeight}vh;`">
            <div class="opacity-color" />
            <img alt="Profile Information Preview"
              :src="`${selectedTemplate.image_file_link}?${(Math.random() + 1).toString(36).substring(7)}`" :style="`
                    height: ${previewHeight}vh; 
                    clip-path: polygon(${maskOptions.hard_skills});
                  `">
          </div>
          <!-- style="
                  height: 60vh; clip-path: polygon(50% 30%, 100% 30%, 100% 70%, 50% 100%);
                " -->
        </div>
      </div>

      <div class="d-flex justify-content-center gap-2">
        <b-button class="mt-4 default-button-style" @click="jumpToStep('education_information_form')">
          Back
        </b-button>

        <b-button class="mt-4 default-button-style" @click="updateResumeData" :disabled="nextButtonDisabled">
          Continue
        </b-button>
      </div>
    </div>

    <!-- STEP soft_skills -->
    <div v-if="currentStep == 'soft_skills'" class="w-100">
      <StepTitle>
        <template v-if="actionType == 'create'">
          We are almost done, let us know what soft skillsets you have
        </template>
        <template v-else>
          Any new soft skills to add?
        </template>
      </StepTitle>

      <div class="mt-2 d-flex flex-row d-md-none w-100 flex-gap-sm">
        <b-button size="sm" :class="`flex-fill default-button${show.preview == true? '-outline' : ''}-color`"
          @click="() => {show.preview = false; show.form = true}"> Form </b-button>
        <b-button size="sm" :class="`flex-fill default-button${show.preview == false? '-outline' : ''}-color`"
          @click="() => {show.preview = true; show.form = false}"> Preview </b-button>
      </div>

      <div :class="customClasses.formContainer">
        <div v-if="show.form" :class="`mt-2 ${customClasses.inputContainer}`">
          <b-row class="justify-content-md-center">
            <b-col cols="12">
              <!-- <h3 class="text-start"> Please tell us what skillsets you have </h3> -->

              <div class="mt-2">
                <form-question>
                  Soft skills
                  <input-required-marker />
                </form-question>

                <!-- <form-question-input v-model="skillInputValue" @on-enter="setSkill"/> -->
                <b-input v-model="softSkillInputValue" v-on:keyup.enter="setSoftSkill($event.target.value)"
                  class="border border-dark" />
                <div class="text-start">
                  <small>Press enter after typing a skill</small>
                </div>

                <div v-if="resumeData.soft_skills.length > 0" class="skills-container d-flex flex-wrap">
                  <div v-for="skill in resumeData.soft_skills" :key="skill.id" class="skill-badge">
                    {{ skill }}
                    <span class="cursor-pointer" aria-hidden="true"><b> &nbsp; &times; </b></span>
                  </div>
                </div>

                <template v-if="false">
                  <h5 class="mt-3 text-start">Suggested Skills</h5>
                  <div class="skills-container d-flex flex-wrap">
                    <div v-for="skill in softSkillsSuggestion" :key="skill.id" class="suggested-skill-badge">
                      {{ skill }}
                      <span class="cursor-pointer" aria-hidden="true"><b> &nbsp; &plus; </b></span>
                    </div>
                  </div>
                </template>
              </div>

            </b-col>
          </b-row>
        </div>

        <div v-if="show.preview" :class="`d-flex justify-content-center ${customClasses.previewContainer}`" class="">
          <div class="preview-container">
            <img alt="Profile Information Preview"
              :src="`${selectedTemplate.image_file_link}?${(Math.random() + 1).toString(36).substring(7)}`"
              :style="`height: ${previewHeight}vh;`">
            <div class="opacity-color" />
            <img alt="Profile Information Preview"
              :src="`${selectedTemplate.image_file_link}?${(Math.random() + 1).toString(36).substring(7)}`" :style="`
                    height: ${previewHeight}vh; 
                    clip-path: polygon(${maskOptions.soft_skills});
                  `">
          </div>
          <!-- style="
                  height: 60vh; clip-path: polygon(50% 30%, 100% 30%, 100% 70%, 50% 100%);
                " -->
        </div>
      </div>

      <div class="d-flex justify-content-center gap-2">
        <b-button class="mt-4 default-button-style" @click="backStep">
          Back
        </b-button>

        <b-button class="mt-4 default-button-style" @click="updateResumeData" :disabled="nextButtonDisabled">
          Continue
        </b-button>
      </div>
    </div>

    <!-- STEP export_to_other_template -->
    <div v-if="currentStep == 'export_to_other_template'" class="w-100">
      <h5 class="font-weight-bolder">
        <b>
          Choose a template
        </b>
      </h5>

      <b-row class="mt-2">
        <b-col v-for="template in templates" :key="template.id" cols="6">
          <img class="mt-2" alt="Resume Template" :src="template" style="width: 100%;"
            @click="selectTemplate(template)">
        </b-col>
      </b-row>
    </div>

    <!-- STEP improvement_suggestion -->
    <div v-if="currentStep == 'improvement_suggestion'" class="w-100">
      <b-row class="justify-content-md-center">
        <b-col cols="12" md="5">
          <h5 class="font-weight-bolder">
            <b>
              LOW MATCH RATE
            </b>
          </h5>

          <div class="my-4">
            <h1 class="custom-text-color"><b>30 %</b></h1>
            <b-progress variant="danger" value="30"> </b-progress>

            <!-- <vue-apex-charts
                          type="pie"
                          height="350"
                          :options="suggestion.chartOptions"
                          :series="suggestion.series"
                      /> -->
            <!-- <doughnut-chart 
                          ref="skills_chart"
                          :chart-data="chartData"
                          :options="chartOptions"
                      /> -->
          </div>
          <h6><b>Rectify the following issues found on your resume</b> to improve your match rate, we recommend a
            match rate of 80% or above</h6>

          <b-card class="mt-4 pt-2 text-start">
            <b-row class="suggestion-scroll-container-header text-start">
              <b-col cols="3">
                <b> Section </b>
              </b-col>
              <b-col>
                <b> Description </b>
              </b-col>
              <b-col cols="3" md="2">
                <b> Action </b>
              </b-col>
            </b-row>

            <div class="suggestion-scroll-container">
              <b-row class="mt-1">
                <b-col cols="3">
                  <!-- Skill and Keywords -->
                  Hard Skills
                </b-col>
                <b-col>
                  <!-- Most of others resume with positionof 'Web Developer' includes skills of 'React', -->
                  <!-- You are missing <b> 4 important high-value skills</b> on your resume, For example <b>Creativity</b> skill is commonly found in other resumes -->
                  You are missing <b>3 important high-value hard skills</b> on your resume. For example, the
                  <b>Database</b> skill is commonly found in other Web Developers' resumes.
                </b-col>
                <b-col cols="3" md="2">
                  <b-button class="custom-button-color" @click="jumpToStep('hard_skills')">
                    Edit
                  </b-button>
                </b-col>
              </b-row>

              <b-row class="mt-1">
                <b-col cols="3">
                  <!-- Skill and Keywords -->
                  Soft Skills
                </b-col>
                <b-col>
                  <!-- Most of others resume with positionof 'Web Developer' includes skills of 'React', -->
                  <!-- You are missing <b> 4 important high-value skills</b> on your resume, For example <b>Creativity</b> skill is commonly found in other resumes -->
                  You are missing <b>6 important high-value soft skills</b> on your resume. For example, the
                  <b>Creativity</b> skill is commonly found in other Web Developers' resumes.
                </b-col>
                <b-col cols="3" md="2">
                  <b-button class="custom-button-color" @click="jumpToStep('soft_skills')">
                    Edit
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-card>

          <div class="d-flex justify-content-center gap-2">
            <b-button class="mt-4 default-button-style" @click="backStep">
              Back
            </b-button>

            <b-button class="mt-4 default-button-style" @click="nextStep">
              Continue
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>

    <!-- STEP finish -->
    <div v-if="currentStep == 'finish'" class="w-100">
      <b-row class="justify-content-md-center">
        <b-col cols="12" md="5">
          <h6 class="font-weight-bolder text-center text-md-center">
            <b>
              Here is your updated resume.
            </b>
          </h6>

          <div class="d-flex justify-content-center">
            <b-overlay :show="resumeData.image_file_link == null" rounded="sm" style="min-height: 28vh;">
              <img 
                class="resume-border mt-2"
                alt="Resume Preview"
                :src="resumeData.image_file_link"
                style="max-height: 28vh;">
            </b-overlay>
          </div>

          <div class="mt-2 d-flex flex-row gap-1 justify-content-center">
            <b-button v-if="false" class="custom-button-color" style="width: 8em;" @click="downloadResumeMsWord"
              :disabled="isLoading">
              <font-awesome-icon icon="fa-solid fa-download" />
              &nbsp; MS Word
            </b-button>

            <a
              :href="resumeData.pdf_file_link"
              download='User Resume.pdf'
            > 
              <b-button 
                class="custom-button-color" 
                style="width: 8em;"
                :disabled="isLoading"
              >
                <feather-icon
                  icon="DownloadIcon"
                  size="16"
                />
                &nbsp; PDF
              </b-button>
            </a>
          </div>

          <hr>

          <div>
            <h6 class="font-weight-bolder text-center text-md-center">
              <b>
                Export to other template?

                <!-- or back to 
                              <b-button class="p-1 custom-button-color ml-4">
                                  <font-awesome-icon icon="fa-solid fa-download" />

                                  Home
                              </b-button> -->
              </b>
            </h6>

            <!-- <div class="alternative-template-export-container">
                          <div v-for="template in templates" :key="template.id" class="alternative-template-export-img-container">
                              <img
                                  class="resume-border"
                                  alt="Resume Template"
                                  :src="template"
                                  @click="selectTemplate(template, false)"
                              >
                          </div>
                      </div> -->


            <b-overlay class="alternative-template-export-container"
              :show="isLoading && resumeData.resume_image_file_link == null" rounded="sm">
              <div class="alternative-template-export-container">
                <div v-for="template in resumeTemplates" :key="template.id"
                  class="alternative-template-export-img-container">
                  <img class="resume-border cursor-pointer" alt="Resume Template"
                    :src="template.image_file_link"
                    @click="displayPopupAlternativeTemplate(template)" />

                  <!-- <component :is="`template-a`" /> -->
                </div>
                <!-- <img
                                  class="resume-border cursor-pointer"
                                  alt="Resume Template"
                                  :src="template"
                                  style="max-height: 45vh;"
                                  @click="nextStep"
                              /> -->
                <!-- @click="selectTemplate(template)" -->
              </div>
            </b-overlay>
          </div>
        </b-col>
      </b-row>
    </div>

    <!-- EDIT choose_resume -->
    <div v-if="currentStep == 'choose_resume'" class="">
      <h5 class="font-weight-bolder">
        <b>
          Select the resume that you want to edit
        </b>
      </h5>

      <b-overlay :show="isLoading" rounded="sm" style="min-height:45vh;">
        <div class="mx-md-5 choose-resume-container">
          <!-- <div v-for="resume in usersResumes" :key="resume.id" class="resume-item"> -->
          <div v-for="resume in usersResumes" :key="resume.id" class="resume-item">
            <img class="resume-border cursor-pointer resune-img" alt="Resume Preview "
              :src="`${resume.resume_image_file_link}?${(Math.random() + 1).toString(36).substring(7)}`"
              style="max-height: 45vh;" @click="selectResumeToEdit(resume.id)">
            <!-- @click="selectTemplate(template)" -->
            <div class="resume-actions">
              <b-button v-b-tooltip.hover.left="'Delete'" class="custom-button-color"
                @click="discardUsersResume(resume.id)">
                <font-awesome-icon icon="fa-solid fa-trash" />
                &nbsp; Discard
              </b-button>
            </div>
          </div>
        </div>
      </b-overlay>

      <div class="d-flex justify-content-center gap-2">
        <router-link :to="{name: 'dashboard'}">
          <b-button class="mt-4 default-button-style">
            Back
          </b-button>
        </router-link>
      </div>
      <!-- <b-row class="mt-2 mt-md-4 mx-md-4">
              <b-col
                  v-for="template in templates" 
                  :key="template.id"
                  cols="6"
                  md="3"
              >
                  <img
                      class="resume-border mt-2 cursor-pointer"
                      alt="Resume Template"
                      :src="template"
                      style="max-width:40vw; max-height: 45vh;"
                      @click="selectTemplate(template)"
                  >
              </b-col>
          </b-row> -->
    </div>

    <!-- EDIT edit_introduction -->
    <div v-if="currentStep == 'edit_introduction'" class="text-start">
      <b-row class="justify-content-md-center">
        <b-col cols="12" md="5">
          <h6 class="m-0 p-0 font-weight-bolder">
            <b>
              You can update the following values in the subsequent pages.
              <br>
              Let’s get started!
            </b>
          </h6>

          <div>
            <small> Items marked with (
              <input-required-marker /> ) are required </small>
          </div>

          <ol class="m-0 mt-2 font-weight-bold">
            <!-- <ol class="mt-2 font-weight-bold"> -->
            <li>
              Personal Information
              <input-required-marker />

              <ul>
                <li>
                  Position you are looking for
                  <input-required-marker />
                </li>
                <li>
                  Name
                  <input-required-marker />
                </li>
                <li>
                  About Me
                  <input-required-marker />
                </li>
              </ul>
            </li>
            <li>
              Contact Information

              <ul>
                <li>
                  Email
                  <input-required-marker /> (Proxy Email available in both Digital and Downloaded resume version)
                </li>
                <li>
                  Phone Number
                  <input-required-marker /> (Proxy Number available in Digital resume version only)
                </li>
                <li>
                  Residential Address
                </li>
                <li>
                  Website
                </li>
              </ul>
            </li>
            <li>
              Employment Information
              <input-required-marker />
            </li>
            <li>
              Education Information
              <input-required-marker />
            </li>
            <li>
              Skills
              <input-required-marker />

              <ul>
                <li>
                  Hard Skills
                  <input-required-marker />
                </li>
                <li>
                  Soft Skills
                  <input-required-marker />
                </li>
              </ul>
            </li>
          </ol>

          <div class="mt-1 d-flex justify-content-center gap-2">
            <b-button class="default-button-style" @click="backStep">
              Back
            </b-button>

            <b-button class="default-button-style" @click="nextStep">
              Continue
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>

    <!-- EDIT employment_information_ask_edit -->
    <div v-if="currentStep == 'employment_information_ask_edit'" class="">
      <b-row class="justify-content-md-center">
        <b-col cols="12" md="5">
          <h5 class="mb-4 font-weight-bolder">
            <b>
              Any changes to your Employment Information?
            </b>
          </h5>

          <div class="scroll-container">
            <!-- v-for="(employment, index) in resumeData.employments" -->
            <b-card v-for="employment in resumeData.employments" :key="employment.id" class="scroll-item my-1">
              <b-row class="d-flex align-items-center">
                <b-col>
                  <b-row class="d-flex align-items-center">
                    <b-col cols="6">
                      <b>
                        {{ employment.position_title }}
                      </b>
                    </b-col>
                    <b-col cols="6">
                      <b> {{ employment.company }} </b>
                      <br>
                      <!-- ( {{ employment.start_date.getFullYear() }} - {{ employment.end_date.getFullYear() }}) -->
                      ( {{ getYear(employment.start_date) }} - {{ getYear(employment.end_date) }})
                    </b-col>
                  </b-row>

                  <hr v-if="employment.job_description" style="margin: 0.2em;">
                  <b-row v-if="employment.job_description">
                    <b-col class="text-start">
                      <small style="white-space: pre-line">
                        {{ employment.job_description }}
                      </small>
                    </b-col>
                  </b-row>
                </b-col>

                <hr v-if="employment.job_description" class="d-md-none" style="margin: 0.2em;">
                <b-col cols="12" md="2" class="d-flex flex-md-column justify-content-center px-0 px-md-1 gap-2">
                  <b-button class="custom-button-color mt-1 mt-md-0 px-4 px-md-2" v-b-tooltip.hover.top="'Edit'"
                    @click="jumpToStep('education_information_form')">
                    <font-awesome-icon icon="fa-solid fa-edit" />

                    <span class="d-md-none">
                      &nbsp; Edit
                    </span>
                  </b-button>

                  <b-button class="custom-button-color mt-1 mt-md-0 px-4 px-md-2" v-b-tooltip.hover.top="'Delete'"
                    @click="jumpToStep('education_information_form')">
                    <font-awesome-icon icon="fa-solid fa-trash" />

                    <span class="d-md-none">
                      &nbsp; Delete
                    </span>
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </div>

          <div class="mt-4 d-flex justify-content-center gap-0 gap-md-2">
            <b-button class="default-button-style" @click="backStep">
              Back
            </b-button>

            <b-button class="icon-button">
              <!-- Add Employment Information -->
              <font-awesome-icon icon="fa-solid fa-plus" />
              <!-- &plus; -->
            </b-button>

            <b-button class="default-button-style" @click="jumpToStep('education_information_ask_edit')">
              Continue
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>

    <!-- EDIT education_information_ask_edit -->
    <div v-if="currentStep == 'education_information_ask_edit'" class="">
      <b-row class="justify-content-md-center">
        <b-col cols="12" md="5">
          <h5 class="mb-4 font-weight-bolder">
            <b>
              Any changes to your Education Information?
            </b>
          </h5>

          <div class="scroll-container">
            <!-- v-for="(employment, index) in resumeData.employment" -->
            <b-card v-for="education in resumeData.educations" :key="education.id" class="scroll-item my-1">
              <b-row class="d-flex align-items-center">
                <b-col>
                  <b-row class="d-flex align-items-center">
                    <b-col cols="6">
                      <b>
                        {{ education.field_of_study }}
                      </b>
                    </b-col>
                    <b-col cols="6">
                      <b> {{ education.institution }} </b>
                      <br>
                      <!-- ( {{ education.start_date.getFullYear() }} - {{ education.end_date.getFullYear() }}) -->
                      ( {{ getYear(education.start_date) }} - {{ getYear(education.end_date) }})
                    </b-col>
                  </b-row>

                  <hr style="margin: 0.2em;" v-if="education.description">
                  <b-row v-if="education.description">
                    <b-col class="text-start">
                      <small style="white-space: pre-line">
                        {{ education.description }}
                      </small>
                    </b-col>
                  </b-row>
                </b-col>

                <hr class="d-md-none" style="margin: 0.2em;">
                <b-col cols="12" md="2" class="d-flex flex-md-column justify-content-center px-0 px-md-1 gap-2">
                  <b-button class="custom-button-color mt-1 mt-md-0 px-4 px-md-2" v-b-tooltip.hover.top="'Edit'"
                    @click="jumpToStep('education_information_form')">
                    <font-awesome-icon icon="fa-solid fa-edit" />

                    <span class="d-md-none">
                      &nbsp; Edit
                    </span>
                  </b-button>

                  <b-button class="custom-button-color mt-1 mt-md-0 px-4 px-md-2" v-b-tooltip.hover.top="'Delete'"
                    @click="jumpToStep('education_information_form')">
                    <font-awesome-icon icon="fa-solid fa-trash" />

                    <span class="d-md-none">
                      &nbsp; Delete
                    </span>
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </div>

          <div class="mt-4 d-flex justify-content-center gap-0 gap-md-2">
            <b-button class="default-button-style" @click="backStep">
              Back
            </b-button>

            <b-button class="icon-button">
              <!-- Add Education Information -->
              <font-awesome-icon icon="fa-solid fa-plus" />
            </b-button>

            <b-button class="default-button-style" @click="jumpToStep('hard_skills')">
              Continue
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>

    <b-modal v-model="popupAlternativeTemplate" centered hide-footer size="lg" title="Use this template?"
      style="height: 100%!important">
      <div class="d-flex flex-column justify-content-center">
        <div class="text-center">
          <img class="resume-border cursor-pointer" alt="Template Image"
            :src="`${popupAlternativeTemplateValue.image_file_link}`"
            style="max-height: 45vh;" />
        </div>
        <div class="text-center mt-2">
          <b-button class="default-button-style" @click="changeTemplate(popupAlternativeTemplateValue)">
            Change To This Template
          </b-button>
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>
import FormQuestion from '@/components/FormQuestion.vue'
import FormQuestionInput from '@/components/FormQuestionInput.vue'
import InputRequiredMarker from '@/components/InputRequiredMarker.vue'

import StepTitle from '@/components/StepTitle.vue'

// import DoughnutChart from '@/components/DoughnutChart.vue'

export default {
  components: {
    FormQuestion,
    FormQuestionInput,
    InputRequiredMarker,
    // DoughnutChart,

    StepTitle,
  },
  data() {
    return {
      show: {
        form: true,
        preview: false,
      },
      previewHeight: 50,
      customClasses: {
        formContainer: 'mt-3 mx-0 mx-md-5 px-2 px-md-5 d-flex flex-md-row flex-wrap-reverse preview-height',
        //* dfesktop
        // inputContainer: 'w-50 w-md-50 flex-fill d-flex flex-column flex-gap-y-md preview-height px-1 px-md-3 overflow-y-auto',
        // previewContainer: 'w-50 w-md-50',

        //* mobile
        inputContainer: 'w-100 w-md-50 flex-fill d-flex flex-column flex-gap-y-md preview-height px-1 px-md-3 overflow-y-auto',
        previewContainer: 'w-100 w-md-50',
      },
      maskOptions: {
        personal_informations: `0% 0%, 100% 0%, 100% 22%, 0% 22%`,
        contact_informations: `0% 25%, 41% 25%, 41% 45%, 0% 45%`,
        employment_informations: `41% 39%, 100% 39%, 100% 96%, 41% 96%`,
        education_informations: `0% 82%, 41% 82%, 41% 94%, 0% 94%`,
        hard_skills: `0% 48%, 41% 48%, 41% 68%, 0% 68%`,
        soft_skills: `0% 69%, 41% 69%, 41% 79%, 0% 79%`,
        about_me: `41% 23%, 100% 23%, 100% 37%, 41% 37%`,
      },
      isLoading: false,
      // actionType: 'create',
      actionType: 'edit',
      usersResumes: [],
      nextButtonDisabled: true,

      resumeData: {
          personal_informations: {
              name: null,
              looking_for_position: null,
              about_me: null,
          },
          contact_informations: {
              email_address: null,
              alias_email_address: null,
              original_email_address: null,
              email_mask: false,
              phone_number: null,
              phone_number_mask: false,
              residential_address :null,
              website: null,
          },
          employments: [
              {
                  position_title: null,
                  company: null,
                  start_date: null,
                  end_date: null,
                  still_work_here: false,
                  job_description: null,
              },
          ],
          educations: [
              {
                  field_of_study: null,
                  institution: null,
                  start_date: null,
                  end_date: null,
                  still_study_here: false,
                  description: null,
                  description_generated: [],
              },
          ],
          soft_skills: [],
          hard_skills: [],
      },

      currentStep: 'choose_template',
      steps: [
        'choose_template',
        // 'introduction',
        'personal_informations',
        'personal_information_field_about_me',

        'contact_informations',

        'employment_information_form',
        'employment_information_ask_add_more',

        'education_information_form',
        'education_information_ask_add_more',

        'hard_skills',
        'soft_skills',

        'finish',
      ],
      stepNumber: 0,
      step: 1,

      employmentStep: 0,
      educationStep: 0,

      // selectedTemplate: require('@/assets/resume-template-1.png'),
      selectedTemplateId: null,
      selectedTemplate: {
        "id": "4ee7bc97-57fb-4e25-a796-2cd4f4403f09",
        "title": "resume_template!4ee7bc97-57fb-4e25-a796-2cd4f4403f09.html",
        "html_file_link": "http://localhost:81/api/resume-templates/html/resume_template!4ee7bc97-57fb-4e25-a796-2cd4f4403f09.html",
        "html_file_path": "E:\\HeadHunters HQ\\e2i-resume-builder-backend\\resume_templates\\html\\resume_template!4ee7bc97-57fb-4e25-a796-2cd4f4403f09.html",
        "html_file_name": "resume_template!4ee7bc97-57fb-4e25-a796-2cd4f4403f09.html",
        "html_file_original_name": null,
        "altered_html_file_link": "http://localhost:81/api/resume-templates/altered-html/altered_resume_template!4ee7bc97-57fb-4e25-a796-2cd4f4403f09.html",
        "altered_html_file_path": "E:\\HeadHunters HQ\\e2i-resume-builder-backend\\resume_templates\\altered_html\\altered_resume_template!4ee7bc97-57fb-4e25-a796-2cd4f4403f09.html",
        "altered_html_file_name": "altered_resume_template!4ee7bc97-57fb-4e25-a796-2cd4f4403f09.html",
        "pdf_file_link": "http://localhost:81/api/resume-templates/pdf/altered_resume_template!4ee7bc97-57fb-4e25-a796-2cd4f4403f09.pdf",
        "pdf_file_path": "E:\\HeadHunters HQ\\e2i-resume-builder-backend\\resume_templates\\pdf\\/altered_resume_template!4ee7bc97-57fb-4e25-a796-2cd4f4403f09.pdf",
        "pdf_file_name": "altered_resume_template!4ee7bc97-57fb-4e25-a796-2cd4f4403f09.pdf",
        "image_file_link": "http://localhost:81/api/resume-templates/image/altered_resume_template!4ee7bc97-57fb-4e25-a796-2cd4f4403f09.jpg",
        "image_file_path": "E:\\HeadHunters HQ\\e2i-resume-builder-backend\\resume_templates\\image\\/altered_resume_template!4ee7bc97-57fb-4e25-a796-2cd4f4403f09.jpg",
        "image_file_name": "altered_resume_template!4ee7bc97-57fb-4e25-a796-2cd4f4403f09.jpg",
        "created_at": "2023-02-22T19:14:03.867689Z",
        "created_by_id": "1309e2b6-8c9d-4d65-8485-4ebe40cb9fbf",
        "updated_at": null,
        "updated_by_id": null,
        "deactivated_at": null,
        "deactivated_by_id": null,
        "section_corrdinates": null
      },
      resumeTemplates: [],
      templates: [],
      userResumes: [],

      hardSkillInputValue: null,
      softSkillInputValue: null,
      max_date_today: new Date(),

      maskEmailCheckbox: false,
      maskPhoneNumberCheckbox: false,
      resumeShareLink: 'jobs.e2i.com.sg/generated-resume/238nskf0asnv89asnlsdfj',

      jobDetailsDatabase: {
        'accountant': {
          position_title: 'accountant',
          job_description: 'managing and the reporting of financial information'
        },
      },

      hardSkillsSuggestion: [
        'Database',
        'Debugging',
        'Frameworks',
        'JavaScript',
        'WordPress',
      ],
      softSkillsSuggestion: [
        'Creativity',
        'Critical Thinking',
        'Adaptability',
        'Collaboration',
        'Confidence',
        'Time Management',
      ],

      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        animation: {
          animateRotate: false,
        },
      },
      chartData: {
        labels: ["skill1"],
        datasets: [{
          backgroundColor: [255, 0, 0],
          data: [1],
        }, ],
      },

      popupAlternativeTemplate: false,
      popupAlternativeTemplateValue: {},
    }
  },
  watch: {
    resumeData: {
      immediate: true,
      deep: true,
      handler(val, oldVal) {
        this.checkNextButtonDisabled()
      },
    },

    currentStep(val, oldVal) {
      if (val === 'finish') {
        this.generateResumeResult()
      }
    },

    isLoading(val, oldVal) {
      this.checkNextButtonDisabled()
    },
  },
  created() {
    this.getResumeTemplates()
    this.getUserData()

    if (this.$route.name === 'manage-resume') {
      this.actionType = 'edit'
      this.getUsersResumes()
    }
  },
  mounted() {
    //
  },
  methods: {
    getUserData() {
      this.$http
        .get(`/api/user`)
        .then(response => {
          const { data } = response

          this.resumeData.personal_informations.user_id = data.eckd
          this.resumeData.personal_informations.name = data.fullname

          this.resumeData.contact_informations.email_address = data.email_address
          this.resumeData.contact_informations.original_email_address = data.email_address
          this.resumeData.contact_informations.phone_number = data.phone_number

          this.getEmployment()
          this.getEducation()
        })
        .catch(error => {})
    },

    getEmployment() {
      this.isLoading = true

      this.$http
        .get('/api/employment-data')
        .then(response => {
          try {
            this.resumeData.employments = []

            response.data.message.forEach(employment => {
              this.resumeData.employments.push(
                {
                  position_title: employment.position,
                  company: employment.company_name,
                  start_date: employment.start_date,
                  end_date: employment.end_date,
                  still_work_here: false,
                  job_description: employment.description,
                }
              )
            })
          } catch (error) {
            this.resumeData.employments = [
              {
                position_title: null,
                company: null,
                start_date: null,
                end_date: null,
                still_work_here: false,
                job_description: null,
              }
            ]
          }

          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
        })
    },
    getEducation() {
      this.isLoading = true

      this.$http
        .get('/api/education-data')
        .then(response => {
          try {
            this.resumeData.educations = []

            response.data.message.forEach(education => {
              this.resumeData.educations.push(
                {
                  field_of_study: education.field_of_study,
                  institution: education.school_name,
                  start_date: education.start_date,
                  end_date: education.end_date,
                  still_study_here: false,
                  description: education.description,
                  description_generated: [],
                },
              )
            })
          } catch (error) {
            //
            this.resumeData.educations = [
              {
                field_of_study: null,
                institution: null,
                start_date: null,
                end_date: null,
                still_study_here: false,
                description: null,
                  description_generated: [],
              }
            ]
          }

          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
        })
    },

    generateResumeResult() {
      this.isLoading = true
      const formData = new FormData()
      formData.append('form_data', JSON.stringify(this.resumeData))

      this.$http
        .post(`/api/users-resumes/${this.selectedTemplateId}/generate-preview`, formData)
        .then(response => {
          const {
            success,
            message,
            output
          } = response.data

          if (!success) {
            this.$toastDanger('An Error Occured', message)
            this.isLoading = false
            return
          }

          this.resumeData.pdf_file_link = this.createDataUri(output.pdf_bytes, 'pdf')
          this.resumeData.image_file_link = this.createDataUri(output.image_bytes, 'jpen')
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          this.$handleResponseError(error)
        })
    },

    getResumeTemplates() {
      this.isLoading = true
      this.resumeTemplates = []
      this.$http
        .get(`/api/resume-templates`)
        .then(response => {
          const {
            success,
            message,
            output
          } = response.data
          if (!success) {
            this.isLoading = false
            this.$toastDanger()
            return
          }
          this.resumeTemplates = output
          this.selectedTemplate = output[1]
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          this.$handleResponseError(error)
        })
    },

    updateResumeData() {
      this.nextStep()
    },
    createNewResume() {
      this.postUsersResume()
      this.nextStep()
    },
    checkNextButtonDisabled() {
      // First stage validation
      let disabled = false

      switch (this.currentStep) {
        case 'personal_information_field_looking_for_position':
          this.nextButtonDisabled = this.$isEmpty(this.resumeData.personal_informations.looking_for_position) ? true : false
          break;
        case 'personal_information_field_name':
          this.nextButtonDisabled = this.$isEmpty(this.resumeData.personal_informations.name) ? true : false
          break;
        case 'personal_information_field_about_me':
          this.nextButtonDisabled = this.$isEmpty(this.resumeData.personal_informations.about_me) ? true : false
          break;
        case 'contact_information_field_email':
          this.nextButtonDisabled = this.$isEmpty(this.resumeData.contact_informations.email_address) ? true : false
          break;
        case 'contact_information_field_phone_number':
          this.nextButtonDisabled = this.$isEmpty(this.resumeData.contact_informations.phone_number) ? true : false
          break;

        case 'personal_informations':
          disabled =
            this.$isEmpty(this.resumeData.personal_informations.name)
            ? true : false
          this.nextButtonDisabled = disabled
          break;
        case 'contact_informations':
          disabled =
            this.$isEmpty(this.resumeData.contact_informations.email_address) ||
            this.$isEmpty(this.resumeData.contact_informations.phone_number)
            ? true : false
          this.nextButtonDisabled = disabled
          break;
        case 'employment_information_form':
          disabled =
            this.$isEmpty(this.resumeData.employments[this.employmentStep].position_title) ||
            this.$isEmpty(this.resumeData.employments[this.employmentStep].company) ||
            this.$isEmpty(this.resumeData.employments[this.employmentStep].start_date) ||
            this.$isEmpty(this.resumeData.employments[this.employmentStep].end_date) ||
            this.$isEmpty(this.resumeData.employments[this.employmentStep].job_description) 
            ? true : false
          this.nextButtonDisabled = disabled
          break;
        case 'education_information_form':
          disabled =
            this.$isEmpty(this.resumeData.educations[this.educationStep].field_of_study) ||
            this.$isEmpty(this.resumeData.educations[this.educationStep].institution) ||
            this.$isEmpty(this.resumeData.educations[this.educationStep].start_date) ||
            this.$isEmpty(this.resumeData.educations[this.educationStep].end_date)
            ? true : false
          this.nextButtonDisabled = disabled
          break;
        case 'hard_skills':
          this.nextButtonDisabled = this.$isEmpty(this.resumeData.hard_skills) ? true : false
          break;
        case 'soft_skills':
          this.nextButtonDisabled = this.$isEmpty(this.resumeData.soft_skills) ? true : false
          break;

        default:
          this.nextButtonDisabled = false
      }

      if (this.isLoading) {
        this.nextButtonDisabled = true
      }
    },

    nextStep() {
      this.stepNumber = this.steps.indexOf(this.currentStep)
      this.stepNumber++

      this.currentStep = this.steps[this.stepNumber]
      this.checkNextButtonDisabled()
    },

    backStep() {
      this.stepNumber = this.steps.indexOf(this.currentStep)
      this.stepNumber--

      this.currentStep = this.steps[this.stepNumber]
      this.checkNextButtonDisabled()
    },
    jumpToStep(stepName) {
      this.stepNumber = this.steps.indexOf(stepName)

      this.currentStep = this.steps[this.stepNumber]
    },

    setSoftSkill(value) {
      if (!this.resumeData.soft_skills.includes(value)) {
        this.resumeData.soft_skills.push(value)
      }
      this.softSkillInputValue = null

      this.checkNextButtonDisabled()
    },
    setHardSkill(value) {
      if (!this.resumeData.hard_skills.includes(value)) {
        this.resumeData.hard_skills.push(value)
      }
      this.hardSkillInputValue = null

      this.checkNextButtonDisabled()
    },

    chooseTemplate(template, nextStep = true) {
      this.selectedTemplateId = template.id
      this.selectedTemplate = template
      this.resumeData.resume_template_id = template.id

      if (nextStep) {
        this.nextStep()
      }
    },
    selectTemplate(value, nextStep = true) { // ! will deprecate this
      this.selectedTemplate = value
      if (nextStep) {
        this.nextStep()
      }
    },
    populateJobDescription(value) {
      if (value.toLowerCase() in this.jobDetailsDatabase) {
        this.resumeData.employments[0].job_description = this.jobDetailsDatabase[value].job_description
      }
    },

    addMoreEmployment() {
      this.employmentStep++

      this.resumeData.employments.push(
        {
          position_title: null,
          company: null,
          start_date: null,
          end_date: null,
          still_work_here: false,
          job_description: null,
        },
      )

      this.jumpToStep('employment_information_form')
    },
    addMoreEducation() {
      this.educationStep++

      this.resumeData.educations.push(
        {
          field_of_study: null,
          institution: null,
          start_date: null,
          end_date: null,
          still_study_here: false,
          description: null,
          description_generated: [],
        },
      )

      this.jumpToStep('education_information_form')
    },

    changeEmploymentEndDate() {
      new Promise((resolve, reject) => {
          if (this.resumeData.employments[this.employmentStep].still_work_here) {
            this.$set(this.resumeData.employments[this.employmentStep], 'end_date', new Date())
            
            setTimeout(() => {
              this.checkNextButtonDisabled()
            }, 100);

            resolve()
          }
          reject()
        })
        .then(() => {
          this.checkNextButtonDisabled()
        })
        .catch(() => {
          this.checkNextButtonDisabled()
        })
    },
    changeEducationEndDate() {
      new Promise((resolve, reject) => {
          if (this.resumeData.educations[this.educationStep].still_study_here) {

            this.$set(this.resumeData.educations[this.educationStep], 'end_date', new Date())

            setTimeout(() => {
              this.checkNextButtonDisabled()
            }, 100);

            resolve()
          }
          reject()
        })
        .then(() => {
          this.checkNextButtonDisabled()
        })
        .catch(() => {
          this.checkNextButtonDisabled()
        })
    },

    getYear(date) {
      if (typeof date === 'string') {
        date = new Date(date)
      }

      return date.getFullYear()
    },
    displayPopupAlternativeTemplate(template) {
      this.popupAlternativeTemplate = true
      this.popupAlternativeTemplateValue = template

    },
    changeTemplate(template) {
      this.resumeData.resume_image_file_link = null
      this.chooseTemplate(template.id, false)
      this.putUsersResume()
        .then(() => {
          this.generateResumeResult()
          this.getUsersResume(this.resumeData.id)
            .then(() => {
              this.popupAlternativeTemplate = false
            })
        })
        .catch(() => {})
    },

    createDataUri(base64Data, fileType) {
      let mimeType = 'application/pdf'
      if (fileType == 'image') {
        mimeType = 'image/jpeg'
      }
      return `data:${mimeType};base64,${base64Data}`
    },
  },
}
</script>
<style lang="scss" scoped>

.default-button-style {
    margin-top: 1em;
    width: 12em;
    margin: 0.3em;

    background-image: linear-gradient(rgb(228,53,91), rgb(240,97,69));
    /* background: linear-gradient(180deg, rgba(228,53,91) 45%, rgba(233,78,92) 10%, rgba(240,97,69) 45%); */
}
.custom-button-color {
    background-image: linear-gradient(rgb(228,53,91), rgb(240,97,69));
}
.icon-button {
    background-image: linear-gradient(rgb(228,53,91), rgb(240,97,69));
    width: 4em;
}

.custom-text-color {
    color: rgb(228,53,91)
}

.resume-border {
    border: solid 1px grey;
}

.input-border {
    border: solid 1px grey;
}

ol > li::marker,
ol > li {
    font-weight: bold;
}
ol > li > ul > li{
    font-weight: normal;
}

.employment-field-container {
    margin-top: 0.5em;
}
.education-field-container {
    margin-top: 0.5em;
}
.skills-container {
    margin: 0.4em 0;
}
.skill-badge {
    margin: 0.3em 0.3em;
    padding: 0.2em 1.0em;

    color: rgb(228,53,91);
    border: solid 0.1em;
    border-radius: 14em;
}

.suggested-skill-badge {
    margin: 0.3em 0.3em;
    padding: 0.2em 1.0em;

    color: rgb(240,97,69);
    border: solid 0.1em;
    border-radius: 14em;
}

.suggested-badge {
    margin: 0.3em 0.3em;
    padding: 0.2em 1.0em;

    color: rgb(240,97,69);
    border: solid 0.1em;
    border-radius: 1rem;
}

.template-export-container {
    margin-top: 2em;
    /* width: 90vw; */
    max-height: 65vh;
    overflow-x: auto;
    white-space: nowrap;
}
.template-export-img-container {
    display: inline-block;
    max-width: 45vw;
    margin: 0;
    margin-right: 3rem;
    padding-bottom: 0.3em;
}
.template-export-img-container:last-child {
    margin-right: 0;
}

.choose-resume-container {
    padding-bottom: 1em;
    margin-top: 2em;
    /* width: 90vw; */
    max-height: 65vh;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    
    .resume-item {
        display: inline-block;
        // max-width: 20vw;
        max-height: 25vh;
        margin: 0;
        margin-right: 4em;
    }
    .resume-item:last-child {
        margin-right: 0em;
    }
}

.resume-item {
    /* position: relative; */
}
.resume-img {
    /* height: 100%: */
}
.resume-actions {
    margin-top: 0.5em;
    /* position: absolute;
    top: 0;
    left: 0; */
}

.alternative-template-export-container {
    /* width: 90vw; */
    /* height: 25vh; */
    overflow-x: auto;
    /* overflow-y: hidden; */
    white-space: nowrap;
    padding-bottom: 0.2em;
}
.alternative-template-export-img-container {
    display: inline-block;
    max-width: 20vw;
    max-height: 15vh;
    margin: 0;
    margin-right: 4em;
}

.alternative-template-export-img-container img {
    max-height: 15vh;
}
.alternative-template-export-img-container:last-child {
    margin-right: 0;
}

.cursor-pointer {
    cursor: pointer;
}

.scroll-container {
    overflow: auto;
    max-height: 55vh;
    padding-right: 0.5em;
}
.suggestion-scroll-container-header {
    padding-right: 0.7em;
}
.suggestion-scroll-container {
    overflow-y: auto;
    overflow-x: hidden;
    /* max-height: 25vh; */
    max-height: 34vh;
    padding-right: 0.5em;
}

.card-body {
    padding: 0.8em;
}

.preview-height {
  height: 50vh;
}

// Extra small (xs)
@media (max-width: 575px) {
  // Your styles for extra small screens here
  .preview-height {
    height: 50vh;
  }
}

// Small (sm)
@media (min-width: 576px) and (max-width: 767px) {
  // Your styles for small screens here
}

// Medium (md)
@media (min-width: 768px) and (max-width: 991px) {
  // Your styles for medium screens here
}

// Large (lg)
@media (min-width: 992px) and (max-width: 1199px) {
  // Your styles for large screens here
}

// Extra large (xl)
@media (min-width: 1200px) {
  // Your styles for extra large screens here
}

.preview-container {
  position: relative;
  // left: -25%;
  @extend .preview-height;

  img:nth-child(1) {
    @extend .preview-height;
    position: absolute;
    top: 0;
    left: 0;
    opacity: .3;
    z-index: 10;
  }

  .opacity-color {
    @extend .preview-height;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    opacity: .1;
    background-color: red;
  }

  img:nth-child(2) {
    @extend .preview-height;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 15;
  }
}
.w-full-vw{
  width: 100vw;
}

.overflow-y-auto {
  overflow-y: auto;
  overflow-x: hidden;
}
</style>



